export const DashboardReport: DASHBOARDREPORTCONFIG = [
  {
    header: "Dashboard Details",
    description: "",
    order: 1,
    menus: [
      {
        icon: "",
        menu: "Vehicle Status",
        menu_description: "",
        url: "/api/vehicle/status",
        method: "GET",
        filters: [],
        columns: [
          {
            uid: "date",
            name: "Date"
          },
          {
            uid: "instituteName",
            name: "Institute"
          },
          {
            uid: "vehicleName",
            name: "Vehicle"
          },
          {
            uid: "vehicleStatus",
            name: "Vehicle Status"
          },
          {
            uid: "hardwareStatus",
            name: "Hardware Status"
          },
          {
            uid: "lastContactTime",
            name: "Last Contact Time"
          }
        ],
        activeColumns: [
          "date",
          "instituteName",
          "vehicleName",
          "vehicleStatus",
          "hardwareStatus",
          "lastContactTime"
        ]
      },
      {
        icon: "",
        menu: "Trip Status",
        menu_description: "",
        url: "/api/trip/status/detail",
        method: "GET",
        filters: ["singleDate"],
        innerFilters: [
          {
            uid: "type",
            label: "Trip Type",
            type: "multiSelect",
            options: [
              {id: 0, name: "Pickup"},
              {id: 1, name: "Drop"}
            ],
            defaultValue: [0, 1]
          },
          {
            uid: "status",
            label: "Trip Status",
            type: "multiSelect",
            options: [
              {id: 1, name: "Yet to start"},
              {id: 2, name: "In progress"},
              {id: 3, name: "Completed"},
              {id: 4, name: "Not completed"}
            ],
            defaultValue: [1, 2, 3, 4]
          }
          // {
          //   uid: "userType",
          //   label: "User Type",
          //   type: "switch",
          //   options: [{id: 1, name: "Students"}],
          //   defaultValue: [1]
          // }
        ],
        columns: [
          {
            uid: "date",
            name: "Date"
          },
          {
            uid: "instituteName",
            name: "Institute"
          },
          {
            uid: "vehicleName",
            name: "Vehicle"
          },
          {
            uid: "tripName",
            name: "Route"
          },
          {
            uid: "tripType",
            name: "Trip Type"
          },
          {
            uid: "tripStartTime",
            name: "Start Time"
          },
          {
            uid: "tripEndTime",
            name: "End Time"
          },
          {
            uid: "tripStatus",
            name: "Status"
          }
        ],
        activeColumns: [
          "date",
          "vehicleName",
          "tripName",
          "tripType",
          "tripStatus"
        ],
        sideBar: [
          {
            type: "card",
            api_url: "/api/trip/status/summary",
            menu: "tripStatus",
            sidebarHeading: ""
          }
        ]
        // tabView: [
        //   {
        //     label: "All",
        //     id: ""
        //   },
        //   {
        //     label: "Yet to Start",
        //     id: 1
        //   },
        //   {
        //     label: "In Progress",
        //     id: 2
        //   },
        //   {
        //     label: "Completed",
        //     id: 3
        //   },
        //   {
        //     label: "Not Completed",
        //     id: 4
        //   }
        // ]
      },
      {
        icon: "",
        menu: "Speed Deviation",
        menu_description: "",
        url: "/api/deviation/speed/detail",
        method: "GET",
        filters: ["date"],
        columns: [
          {
            uid: "vehicleName",
            name: "Vehicle"
          },
          {
            uid: "deviationTime",
            name: "Deviation Time"
          },
          {
            uid: "speed",
            name: "Speed"
          },
          {
            uid: "threshold",
            name: "Threshold (Km)"
          }
        ],
        activeColumns: ["vehicleName", "deviationTime", "speed", "threshold"],
        sideBar: [
          {
            type: "card",
            api_url: "/api/deviation/speed",
            menu: "speedDeviation",
            sidebarHeading: ""
          }
        ]
      },
      {
        icon: "",
        menu: "Distance Driven",
        menu_description: "",
        url: "/api/distance/driven/detail",
        method: "GET",
        filters: ["date"],
        columns: [
          {
            uid: "date",
            name: "Date"
          },
          // {
          //   uid: "instituteName",
          //   name: "Institute"
          // },
          {
            uid: "vehicleName",
            name: "Vehicle"
          },
          {
            uid: "scheduled",
            name: "Scheduled Kms"
          },
          {
            uid: "unScheduled",
            name: "Unscheduled Kms"
          }
        ],
        activeColumns: [
          "date",
          "instituteName",
          "vehicleName",
          "scheduled",
          "unScheduled"
        ],
        sideBar: [
          {
            type: "card",
            api_url: "/api/distance/driven/summary",
            menu: "distanceDriven",
            sidebarHeading: ""
          }
        ]
      },
      {
        icon: "",
        menu: "Distance Deviation",
        menu_description: "",
        url: "/api/deviation/distance/detail",
        method: "GET",
        filters: ["date"],
        //vehicleName,threshold
        columns: [
          {
            uid: "vehicleName",
            name: "Vehicle"
          },
          {
            uid: "deviationTime",
            name: "Deviation Time"
          },
          {
            uid: "totalDistance",
            name: "Distance"
          },
          {
            uid: "thresholdStr",
            name: "Threshold"
          }
        ],
        activeColumns: [
          "vehicleName",
          "deviationTime",
          "totalDistance",
          "thresholdStr"
        ],
        sideBar: [
          {
            type: "card",
            api_url: "/api/deviation/distance",
            menu: "distanceDeviation",
            sidebarHeading: ""
          }
        ]
      },
      {
        icon: "",
        menu: "Bus Attendance",
        menu_description: "",
        url: "/api/busAttendance",
        method: "GET",
        filters: [],
        columns: [
          {
            uid: "date",
            name: "Date"
          },
          {
            uid: "instituteName",
            name: "Institute"
          },
          {
            uid: "name",
            name: "Name"
          },
          {
            uid: "className",
            name: "Class"
          },
          {
            uid: "enrollNo",
            name: "Enroll No"
          },
          {
            uid: "in_pick_time",
            name: "Pickup"
          },
          {
            uid: "out_drop_time",
            name: "Drop"
          },
          {
            uid: "other_swipes_time",
            name: "Other Swipes"
          },
          {
            uid: "attendanceStatus",
            name: "Status"
          }
        ],
        activeColumns: [
          "date",
          "instituteName",
          "name",
          "className",
          "enrollNo",
          "in_pick_time",
          "out_drop_time",
          "other_swipes_time",
          "attendanceStatus"
        ]
      },
      {
        icon: "",
        menu: "Campus Attendance",
        menu_description: "",
        url: "/api/campusAttendance",
        method: "GET",
        filters: [],
        columns: [
          {
            uid: "date",
            name: "Date"
          },
          {
            uid: "instituteName",
            name: "Institute"
          },
          {
            uid: "name",
            name: "Name"
          },
          {
            uid: "className",
            name: "Class"
          },
          {
            uid: "enrollNo",
            name: "Enroll No"
          },
          {
            uid: "in_pick_time",
            name: "In Time"
          },
          {
            uid: "out_drop_time",
            name: "Out Time"
          },
          {
            uid: "other_swipes_time",
            name: "Other Swipes"
          },
          {
            uid: "attendanceStatus",
            name: "Status"
          }
        ],
        activeColumns: [
          "date",
          "instituteName",
          "name",
          "className",
          "enrollNo",
          "in_pick_time",
          "out_drop_time",
          "other_swipes_time",
          "attendanceStatus"
        ]
      },
      {
        icon: "",
        menu: "Insurance Summary",
        menu_description: "",
        url: "api/insurance/summary",
        method: "GET",
        filters: [],
        columns: [
          {
            uid: "institutionName",
            name: "Institute"
          },
          {
            uid: "vehicleName",
            name: "Vehicle"
          },
          {
            uid: "regNo",
            name: "RegNo"
          },
          {
            uid: "validUpto",
            name: "Valid Upto"
          },
          {
            uid: "documentNumber",
            name: "Document Number"
          },
          {
            uid: "issuerName",
            name: "Issuer Name"
          },
          {
            uid: "status",
            name: "Status"
          }
        ],
        activeColumns: [
          "institutionName",
          "vehicleName",
          "regNo",
          "validUpto",
          "documentNumber",
          "issuerName",
          "status"
        ],
        tabView: [
          {
            label: "All",
            id: ""
          },
          {
            label: "Active Policies",
            id: 1
          },
          {
            label: "Expired Policies",
            id: 2
          },
          {
            label: "No Data",
            id: 3
          }
        ]
      },
      {
        icon: "",
        menu: "Permit Summary",
        menu_description: "",
        url: "api/permit/summary",
        method: "GET",
        filters: [],
        columns: [
          {
            uid: "institutionName",
            name: "Institute"
          },
          {
            uid: "vehicleName",
            name: "Vehicle"
          },
          {
            uid: "regNo",
            name: "RegNo"
          },
          {
            uid: "validUpto",
            name: "Valid Upto"
          },
          {
            uid: "documentNumber",
            name: "Document Number"
          },
          {
            uid: "issuerName",
            name: "Issuer Name"
          },
          {
            uid: "status",
            name: "Status"
          }
        ],
        activeColumns: [
          "institutionName",
          "vehicleName",
          "regNo",
          "validUpto",
          "documentNumber",
          "issuerName",
          "status"
        ],
        tabView: [
          {
            label: "All",
            id: ""
          },
          {
            label: "Active Permits",
            id: 1
          },
          {
            label: "Expired Permits",
            id: 2
          },
          {
            label: "No Data",
            id: 3
          }
        ]
      },
      {
        icon: "",
        menu: "Pollution Summary",
        menu_description: "",
        url: "api/pollution/summary",
        method: "GET",
        filters: [],
        columns: [
          {
            uid: "institutionName",
            name: "Institute"
          },
          {
            uid: "vehicleName",
            name: "Vehicle"
          },
          {
            uid: "regNo",
            name: "RegNo"
          },
          {
            uid: "validUpto",
            name: "Valid Upto"
          },
          {
            uid: "documentNumber",
            name: "Document Number"
          },
          {
            uid: "status",
            name: "Status"
          }
        ],
        activeColumns: [
          "institutionName",
          "vehicleName",
          "regNo",
          "validUpto",
          "documentNumber",
          "status"
        ],
        tabView: [
          {
            label: "All",
            id: ""
          },
          {
            label: "Active PC",
            id: 1
          },
          {
            label: "Expired PC",
            id: 2
          },
          {
            label: "No Data",
            id: 3
          }
        ]
      },
      {
        icon: "",
        menu: "Total Attendance",
        menu_description: "",
        url: "/api/allAttendance",
        method: "GET",
        filters: ["singleDate"],
        columns: [
          {
            uid: "date",
            name: "Date"
          },
          {
            uid: "instituteName",
            name: "Institute"
          },
          {
            uid: "name",
            name: "Name"
          },
          {
            uid: "className",
            name: "Class"
          },
          {
            uid: "enrollNo",
            name: "Enroll No"
          },
          // {
          //   uid: "in_pick_time",
          //   name: "Pickup"
          // },
          // {
          //   uid: "out_drop_time",
          //   name: "Drop"
          // },
          {
            uid: "attendance_status",
            name: "Status"
          }
        ],
        activeColumns: [
          "date",
          "instituteName",
          "name",
          "className",
          "enrollNo",
          "in_pick_time",
          "out_drop_time",
          "attendance_status"
        ]
      }
    ]
  }
];
